import {
  remoteResourceInitialState,
  remoteResourceLoading,
  remoteResourceLoadSuccess,
  remoteResourceLoadFailure,
} from '../../helpers';
import { Actions, ActionType, State } from './types';

const initialState: State = {
  list: remoteResourceInitialState([]),
  save: remoteResourceInitialState(null),
  remove: remoteResourceInitialState(null),
};

const reducer = (state: State = initialState, action: Actions): State => {
  switch (action.type) {
    case ActionType.listRequested:
      return { ...state, list: remoteResourceLoading([]) };

    case ActionType.listSuccess:
      return { ...state, list: remoteResourceLoadSuccess(action.data) };

    case ActionType.listFailure:
      return { ...state, list: remoteResourceLoadFailure([], action.error) };

    case ActionType.createRequested:
    case ActionType.updateRequested:
      return { ...state, save: remoteResourceLoading(null) };

    case ActionType.createSuccess:
      return {
        ...state,
        save: remoteResourceLoadSuccess(null),
        list: remoteResourceLoadSuccess([...state.list.data, action.data]),
      };

    case ActionType.updateSuccess:
      return {
        ...state,
        save: remoteResourceLoadSuccess(null),
        list: remoteResourceLoadSuccess(
          state.list.data.map(item =>
            item.country === action.country && item.code === action.code
              ? { ...item, store: action.payload.store, store_name: action.payload.store_name }
              : item
          )
        ),
      };

    case ActionType.createFailure:
    case ActionType.updateFailure:
      return { ...state, save: remoteResourceLoadFailure(null, action.error) };

    case ActionType.deleteRequested:
      return { ...state, remove: remoteResourceLoading(null) };

    case ActionType.deleteSuccess:
      return {
        ...state,
        remove: remoteResourceLoadSuccess(null),
        list: remoteResourceLoadSuccess(
          state.list.data.filter(
            item => !(item.country === action.country && item.code === action.code)
          )
        ),
      };

    case ActionType.deleteFailure:
      return { ...state, remove: remoteResourceLoadFailure(null, action.error) };

    default:
      return state;
  }
};

export default reducer;
